<template>
    <div
        role="dialog"
        aria-modal="true"
        :aria-describedby="describedBy"
        :aria-labelledby="labelledBy"
    >
        <div
            :class="{
        [$style.modalContent]: true,
        [$style.modalStandard]: !small && !large,
        [$style.modalSmall]: small,
        [$style.modalLarge]: large
      }"
        >
            <div
                :class="$style.closeIcon"
                tabindex="0"
                role="button"
                aria-label="close dialog"
                ref="closeButton"
                @click="close"
                @keyup.enter="close"
                @keyup.space="close"
                @keydown.esc="close"
            >
                <FontAwesomeIcon :icon="closeIcon" :class="$style.icon" size="lg" />
            </div>

            <div v-if="showSlot('header')" :class="$style.header">
                <slot name="header" />
            </div>
            <div v-if="showSlot('message')" :class="$style.message">
                <slot name="message" />
            </div>
            <slot v-if="showSlot('content')" name="content" :class="$style.content" />
        </div>
        <div
            :class="{ [$style.modalMask]: true, [$style.blur]: blurBackground }"
            @click="close"
            @keydown.esc="close"
        />
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

export default {
    name: 'MarmotModal',
    components: {
        FontAwesomeIcon
    },
    props: {
        labelledBy: String,
        describedBy: String,
        small: Boolean,
        large: Boolean,
        blurBackground: Boolean
    },
    mounted() {
        this.$refs.closeButton.focus()
    },
    computed: {
        closeIcon() {
            return faTimes
        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
        showSlot(slotName) {
            return Boolean(this.$slots[slotName])
        }
    }
}
</script>

<style module src="./Modal.css" />
